import { render, staticRenderFns } from "./SithMesStoolPrEdit.vue?vue&type=template&id=0a1282c2&"
import script from "./SithMesStoolPrEdit.vue?vue&type=script&lang=js&"
export * from "./SithMesStoolPrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports